// The idle-timeout hook publishes its clock here so the silent app-update gate
// can refuse to reload close to an inactivity sign-out. null = nobody published
// (the gate fails closed).

let clock = null;

export function publishIdleClock(next) {
  clock = next;
  return () => { if (clock === next) clock = null; };
}

export function readIdleClock() {
  return clock;
}
